import { Button } from '@mui/material'

import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'

export const StyledButton = withStyles(theme => ({
  root: {
    position: 'absolute',
    bottom: '3rem',
    right: '1.5rem',
    borderRadius: '50%',
    width: '4rem',
    height: '4rem',
    padding: '0.75rem 1rem',
    background: `linear-gradient(276deg, ${theme.gradient.button.start} 0%, ${theme.gradient.button.stop} 100%)`,
    fontSize: theme.size.xxl,
    color: 'white'
  }
}))(Button)

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    height: '100%'
  },

  menuAnchor: {
    position: 'relative'
  },

  menu: {
    zIndex: '2',
    position: 'absolute',
    bottom: '-0.5rem',
    right: '-0.5rem',
    display: 'flex',
    flexDirection: 'column'
  },

  backdrop: {
    zIndex: '1',
    position: 'absolute',
    top: '0',
    left: '0',
    transform: 'translate(-50%, -50%)',
    width: '300vw',
    height: '300svh'
  },

  button: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.5rem',
    borderRadius: '100rem',
    boxSizing: 'border-box',
    boxShadow: '0 0.5rem 1.25rem 0 rgba(66, 81, 89, 0.3)',
    padding: '0.5625rem 1.6875rem 0.5625rem 0.5625rem',
    backgroundColor: 'white',
    fontSize: theme.size.sm,
    whiteSpace: 'nowrap',
    color: '#323436',
    cursor: 'pointer',

    '&:hover': {
      background: `linear-gradient(276deg, ${theme.gradient.button.start} 0%, ${theme.gradient.button.stop} 100%)`,
      color: 'white'
    },

    '&:hover *': {
      borderColor: 'white !important',
      color: 'white !important'
    }
  },

  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '0.875rem',
    width: 'auto',
    height: '2.25rem',
    border: '0.0625rem solid',
    borderRadius: '50%',
    boxSizing: 'border-box',
    padding: '0.4375rem',
    fontSize: theme.size.lg
  }
}))

export default useStyles
